import { useEffect, useState } from "react";
import GuarantorDocumentUpload from "../LoanApplication/GuarantorDocumentUpload";
import GuarantorTabs from "../LoanApplication/GuarantorTabs";
import { Button, Col, Row } from "antd";
import { useNavigate } from "react-router";
import {
    checkValidations,
    hasKeysAndNotEmpty,
    reverseObject,
    validateRequiredFields,
} from "../../common/Utilities";
import { RequiredFields } from "../../common/RequiredFields";
import { ServerAPI } from "../../common/ServerAPI";
import { toast } from "react-toastify";
import EditSignatureUpload from "../LoanApplication/EditSignatureUpload";
import { removeGuarantorLabel, } from "../../redux/slice/guarantorInfoSlice";
import { useDispatch, useSelector } from "react-redux";

const GurantorEdit = (props) => {
    const { editType, NotificationGuarantorId, clickAddBtn, setClickAddBtn, existingGuarantors } = props;
    const { setGuarntorEdit, reloadData } = props.comp;
    const dispatch = useDispatch();
    const [guarantorCount, setGuarantorCount] = useState(0);
    const getButtonId = useSelector((state) => state.guarantorInfo.guarantorButtonId);
    const guarantorCountUpdate = (value) => {
        setGuarantorCount(value);
    };
    const loanApplicationUpdate = async (dataKeyValue, value, showToast) => {
        const response = await ServerAPI.updateApplication(dataKeyValue, value);
        sessionStorage.setItem("updated", true);
        if (response && showToast) {
            toast.success(response.message);
        }
    };
    const guarantorValidator = () => {
        if (guarantorCount != 0) {
            let guarantorDetails = [];
            let totalCount = localStorage.getItem("guarantorcount");
            let validationResult = false;
            let validationCompletion = false;

            for (let index = 1; index <= totalCount; index++) {
                let data = {};
                let savedGuarantorData = JSON.parse(
                    localStorage.getItem("guarantor_details_" + index)
                );
                let savedGuarantorDetails = JSON.parse(
                    localStorage.getItem("guarantor_personal_details_" + index)
                );
                let savedGuarantorEmployemnt = JSON.parse(
                    localStorage.getItem("guarantor_employement_details_" + index)
                );
                let savedGuarantorDocuments = JSON.parse(
                    localStorage.getItem("guarantor_documents_" + index)
                );
                let savedGuarantorSignDocuments = JSON.parse(
                    localStorage.getItem("guarantor_sign_documents_" + (index - 1))
                );
                let completionResultData = false;
                let completionResultEmployemnt = false;
                let completionResultDocuments = false;
                if (
                    !savedGuarantorData ||
                    !savedGuarantorDetails ||
                    !savedGuarantorEmployemnt
                ) {
                    validationResult = false;
                }
                if (!savedGuarantorDocuments) {
                    validationCompletion = false;
                }
                if (savedGuarantorData && savedGuarantorDetails) {
                    if (savedGuarantorData.guarantor_type == "company") {
                        completionResultEmployemnt = true;
                        completionResultData = hasKeysAndNotEmpty(
                            savedGuarantorData,
                            RequiredFields.guarantor_data_company
                        );
                    } else {
                        completionResultData = hasKeysAndNotEmpty(
                            savedGuarantorData,
                            RequiredFields.guarantor_data_individual
                        );
                        completionResultEmployemnt = checkValidations(
                            savedGuarantorEmployemnt
                        );
                    }
                    let completionResultDetail = checkValidations(savedGuarantorDetails);
                    if (savedGuarantorDocuments) {
                        if (savedGuarantorData.guarantor_type == "individual") {
                            completionResultDocuments = validateRequiredFields(
                                savedGuarantorDocuments,
                                RequiredFields.applicant_documents
                            );
                        } else {
                            completionResultDocuments = validateRequiredFields(
                                savedGuarantorDocuments,
                                RequiredFields.company_applicant_documents
                            );
                        }
                    }
                    if (
                        completionResultData == true &&
                        completionResultDetail == true &&
                        completionResultEmployemnt == true &&
                        completionResultDocuments == false
                    ) {
                        validationResult = true;
                        validationCompletion = false;
                        data["guarantor_type"] = savedGuarantorData.guarantor_type;
                        data["guarantor_citizenship_type"] =
                            savedGuarantorData.guarantor_citizenship_type;
                        data["guarantor_nric"] = savedGuarantorDetails.nric?.value
                            ? savedGuarantorDetails?.nric?.value
                            : savedGuarantorDetails?.uen_acra_no?.value;
                        data["personal_details"] = reverseObject(savedGuarantorDetails);
                        data["employement_details"] = reverseObject(
                            savedGuarantorEmployemnt
                        );
                        data["documents"] = null;
                        data["notification_guarantor_id"] = NotificationGuarantorId;
                    } else if (
                        completionResultData == true &&
                        completionResultDetail == true &&
                        completionResultEmployemnt == true &&
                        completionResultDocuments == true
                    ) {
                        validationResult = true;
                        validationCompletion = true;
                        data["guarantor_type"] = savedGuarantorData.guarantor_type;
                        data["guarantor_citizenship_type"] =
                            savedGuarantorData.guarantor_citizenship_type;
                        data["guarantor_nric"] = savedGuarantorDetails.nric?.value
                            ? savedGuarantorDetails?.nric?.value
                            : savedGuarantorDetails?.uen_acra_no?.value;
                        data["personal_details"] = reverseObject(savedGuarantorDetails);
                        data["employement_details"] = reverseObject(
                            savedGuarantorEmployemnt
                        );
                        data["documents"] = {
                            ...savedGuarantorDocuments,
                            guarantor_signature: savedGuarantorSignDocuments
                                ?.guarantor_signature?.value
                                ? savedGuarantorSignDocuments?.guarantor_signature?.value
                                : "",
                        };
                        data["notification_guarantor_id"] = getButtonId;
                    }
                }
                guarantorDetails.push(data);
            }
            if (validationCompletion == true && validationResult == true) {
                //added
                loanApplicationUpdate("guarantor_details", guarantorDetails, true);
                dispatch(removeGuarantorLabel(getButtonId));
                // console.log("first------->>>");
                localStorage.setItem("redirectStatus", false);
                setGuarntorEdit(false);
            } else if (validationCompletion == false && validationResult == true) {
                loanApplicationUpdate("guarantor_details", guarantorDetails, false);
                toast.error("Please Complete Guarantor Details");
                setGuarntorEdit(true);
                // console.log("second")
            } else {
                setGuarntorEdit(true);
                toast.error("Please Complete Guarantor Details");
                // console.log("third")
            }
        } else {
            // console.log("forth")
            setGuarntorEdit(false);
            reloadData();
        }
        reloadData();
    };
    useEffect(() => {
        if (localStorage.getItem("guarantorcount")) {
            setGuarantorCount(localStorage.getItem("guarantorcount"));
        }
    }, [localStorage]);

    return (
        <div className="w-full min-h-screen overflow-x-clip">
            <div className="bg-white">
                <Row gutter={[24, 24]} className="pb-[20px]">
                    <Col xs={24} sm={12} md={15} lg={15}>
                        <div className="text-[18px] font-[700] bg-white flex">
                            <div
                                className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer"
                                onClick={() => setGuarntorEdit(false)}
                            >
                                <img src="/images/left-circle.svg" alt="arrow" />
                            </div>
                            <p>Edit {editType} Details</p>
                        </div>
                    </Col>
                </Row>
            </div>
            <GuarantorTabs
                updateFunction={() => console.log("hi")}
                guarantorCountUpdator={guarantorCountUpdate}
                isApplicationGuarantor={true}
                NotificationGuarantorId={NotificationGuarantorId}
                setClickAddBtn={setClickAddBtn}
                clickAddBtn={clickAddBtn}
                existingGuarantors={existingGuarantors}
            />
            <div className="mb-[20px] text-end">
                <Button
                    type="default"
                    className="rounded-[4px] font-[500] h-[40px] min-w-[120px]"
                    onClick={() => setGuarntorEdit(false)}
                >
                    Cancel
                </Button>
                <Button
                    type="primary"
                    className="rounded-[4px] font-[500] h-[40px] min-w-[120px] ml-[20px]"
                    onClick={() => {
                        guarantorValidator();
                    }}
                >
                    Update
                </Button>
            </div>
        </div>
    );
};

export default GurantorEdit;
